const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/discord-linked.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/discord-linked")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});